import globalStoreActions from '@constans/store/global/globalStoreActions';
import globalStoreMutations from '@constans/store/global/globalStoreMutations';
const actions = {
    [globalStoreActions.SET_SNACKBAR]: ({ commit }, data) => {
        commit(globalStoreMutations.UPDATE_SNACBAR, data);
        // Clear after 5 sec
        setTimeout(() => commit(globalStoreMutations.UPDATE_SNACBAR, null), 5000);
    }
};
export default actions;
